module.exports = __webpack_public_path__ + "static/media/viska.2d68d09e.mp3";